module.exports = __webpack_public_path__ + "media/images/icons/present-color-icon-250e4235cf1dc596a0ab3dd738c76671.svg";